// Angular and RJX Imports
// =========================================================
import { Component, Input, type OnInit, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-dashboard-tile',
  templateUrl: './dashboard-tile.component.html',
  styleUrls: ['./dashboard-tile.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class DashboardTileComponent implements OnInit {
  @Input() category: any

  constructor (public router: Router) {}
  ngOnInit (): void {
    console.log('category: ', this.category)
    if (this.category.name == 'Execution') {
      this.category.children.forEach(child => child.is_enabled = environment.btl)
    }
  }

  onClickNav (path: string) {
    console.log('navigate to: ', path)
    this.router.navigateByUrl(path)
  }
}
